import { Component, OnInit } from '@angular/core';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import { LeadsService } from '../../_service/leads.service';
import { SharedService } from '../../_service/shared.service';
import { ActivatedRoute, Router  } from '@angular/router';
import { DoctorService } from '../../_service/doctor.service';

@Component({
  selector: 'app-update-circle-cities',
  templateUrl: './update-circle-cities.component.html',
  styleUrls: ['./update-circle-cities.component.css']
})
export class UpdateCircleCitiesComponent implements OnInit {
  circles=[];cities=[];cities_copy=[]; circleId:any;circleName:string;
  allassignedcities = []; allassignedcities_copy=[]; noCities:boolean=false;loading:boolean=false;
  constructor(private leadapi:LeadsService,private sharedapi:SharedService,private router:Router,private activatedRoute: ActivatedRoute,private doctorapi:DoctorService) { 
    this.activatedRoute.params.subscribe(params => {
      console.log(params);
      if (params['circle_id']) {
          this.circleId = params['circle_id'];
          this.circleName= params['circle_name'];
          this.getcirclewisecity();
      }

    });
      this.getcity();
   }

  ngOnInit(): void {
  }
  async getcirclewisecity()
  {
      let qString = 'circle='+this.circleId;
      await this.doctorapi.getCircle_cities(qString).subscribe((data:any) => {
          if(data.status)
          {
              this.allassignedcities = data.data;
              this.allassignedcities_copy= this.allassignedcities;
          }else{
              this.allassignedcities = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  async getcity()
    {
        await this.leadapi.getcities().subscribe((data:any) => {
            if(data.status)
            {
                this.cities = data.data;
                this.cities_copy= this.cities;
            }else{
                this.cities = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }
  
  searchOnSelect(searchtText: string, type){
      if (type == 'allcity') {
          this.cities = this.sharedapi.searchData(searchtText, this.cities_copy, "name");
      }else if(type='assignedcity'){
          this.allassignedcities = this.sharedapi.searchData(searchtText, this.allassignedcities_copy, "name");
      }
  }  

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      if(this.allassignedcities.length < 0){
        this.noCities=false;
      }else{
        this.noCities=true;
      }
      transferArrayItem(event.previousContainer.data,
                        event.container.data,
                        event.previousIndex,
                        event.currentIndex);
    }
  }

  async updateData(){
    if(this.allassignedcities.length > 0){
        this.loading = true;
        this.noCities=false;
        var data= {
          'circleId': this.circleId,
          'cities': this.allassignedcities
        }
        console.log(data);
        await this.leadapi.updateCircleCities(data)
        .subscribe((data:any) => {
            // this.submitted = false;
            this.loading = false;
            if(data.status)
            {
                this.sharedapi.presentToast('Cities Updated Successfully');
                this.router.navigateByUrl('/manage-circle-city');
            }
            else
            {
              this.loading = false; 
              this.sharedapi.presentToast(data.msg);
            }
          }, error => 
            {
                this.sharedapi.checkError(error);
            });

    }else{
        this.noCities=true;
        this.loading = false;
    }
    console.log(this.allassignedcities);
  }

}
